(() => {
  const makeCanvas = (width, height) => Object.assign(document.createElement('canvas'), { width, height });
  const loadImage = (url) => new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Image could not be loaded.'));
    image.src = url;
  });
  const project = (q, u, v) => ({
    x: (1-u)*(1-v)*q[0][0] + u*(1-v)*q[1][0] + u*v*q[2][0] + (1-u)*v*q[3][0],
    y: (1-u)*(1-v)*q[0][1] + u*(1-v)*q[1][1] + u*v*q[2][1] + (1-u)*v*q[3][1]
  });
  const triangle = (ctx, image, source, target) => {
    const [a,b,c] = source;
    const [p,q,r] = target;
    const d = a.x*(b.y-c.y)+b.x*(c.y-a.y)+c.x*(a.y-b.y);
    const coefficient = (key) => [
      (p[key]*(b.y-c.y)+q[key]*(c.y-a.y)+r[key]*(a.y-b.y))/d,
      (p[key]*(c.x-b.x)+q[key]*(a.x-c.x)+r[key]*(b.x-a.x))/d,
      (p[key]*(b.x*c.y-c.x*b.y)+q[key]*(c.x*a.y-a.x*c.y)+r[key]*(a.x*b.y-b.x*a.y))/d
    ];
    const x = coefficient('x'), y = coefficient('y');
    ctx.save(); ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(q.x,q.y); ctx.lineTo(r.x,r.y); ctx.closePath(); ctx.clip();
    ctx.setTransform(x[0],y[0],x[1],y[1],x[2],y[2]); ctx.drawImage(image,0,0); ctx.restore();
  };
  const warp = (ctx, image, q) => {
    const cells = 12;
    for (let y=0;y<cells;y++) for(let x=0;x<cells;x++) {
      const uv = [[x/cells,y/cells],[(x+1)/cells,y/cells],[(x+1)/cells,(y+1)/cells],[x/cells,(y+1)/cells]];
      const s = uv.map(([u,v]) => ({x:u*image.width,y:v*image.height}));
      const t = uv.map(([u,v]) => project(q,u,v));
      triangle(ctx,image,[s[0],s[1],s[2]],[t[0],t[1],t[2]]);
      triangle(ctx,image,[s[0],s[2],s[3]],[t[0],t[2],t[3]]);
    }
  };
  document.querySelectorAll('[data-packaging-preview]').forEach((root) => {
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    const $ = (s) => root.querySelector(s);
    const canvas = $('canvas'), ctx = canvas.getContext('2d');
    const controls = {size:$('[data-pkg-size]'),x:$('[data-pkg-x]'),y:$('[data-pkg-y]'),ink:$('[data-pkg-ink]'),paper:$('[data-pkg-paper]'),remove:$('[data-pkg-remove-white]')};
    const status = $('[data-pkg-status]');
    const views = {
      lid:{size:'55',x:'50',y:'50',ink:'white',paper:'dark',remove:false},
      insert:{size:'70',x:'50',y:'50',ink:'white',paper:'dark',remove:false}
    };
    let view='lid', original=false, logo=null, filename='', images=null, uploadVersion=0, frame=0;
    const showPreview = () => {if(window.matchMedia('(max-width:749px)').matches)$('.csb-packaging-visual').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth',block:'start'});};
    $('[data-pkg-show]').addEventListener('click',showPreview);
    const announce = (text,error=false) => {status.textContent=text;status.dataset.error=String(error);};
    const sample = makeCanvas(640,280);
    const sampleContext = sample.getContext('2d');
    sampleContext.fillStyle='#fff';sampleContext.textAlign='center';sampleContext.font='500 82px Arial, sans-serif';sampleContext.fillText('YOUR LOGO',320,130);sampleContext.font='22px Arial, sans-serif';sampleContext.fillText('MAKE IT YOURS',320,194);
    let prepared = sample;
    const prepare = () => {
      const input = logo || sample;
      const scaled = makeCanvas(input.width,input.height);
      const context=scaled.getContext('2d');context.drawImage(input,0,0);
      if(controls.remove.checked && logo){
        const data=context.getImageData(0,0,scaled.width,scaled.height);
        for(let i=0;i<data.data.length;i+=4){
          const min=Math.min(data.data[i],data.data[i+1],data.data[i+2]);
          if(min>210) data.data[i+3]=Math.round(data.data[i+3]*(255-min)/45);
        }
        context.putImageData(data,0,0);
      }
      if(controls.ink.value!=='original'){
        context.globalCompositeOperation='source-in';
        context.fillStyle={white:'#f5f5f3',silver:'#bfc3c7',black:'#181b20'}[controls.ink.value];
        context.fillRect(0,0,scaled.width,scaled.height);
      }
      prepared=scaled;
    };
    const render = () => {
      frame=0;if(!images)return;
      const offset = view==='lid' ? -100 : 0;
      ctx.setTransform(1,0,0,1,0,0);ctx.fillStyle='#fff';ctx.fillRect(0,0,1000,900);
      const base = view==='lid' ? (original ? images.original : images.blank) : images.open;
      ctx.drawImage(base,0,offset,1000,1000);
      if(!original){
        const surface=makeCanvas(1000,view==='lid'?480:1400);
        const surfaceContext=surface.getContext('2d');
        if(view==='insert'){
          const g=surfaceContext.createLinearGradient(0,0,1000,1400);
          if(controls.paper.value==='light'){g.addColorStop(0,'#f6f6f4');g.addColorStop(1,'#dededb');}
          else{g.addColorStop(0,'#444540');g.addColorStop(1,'#33342f');}
          surfaceContext.fillStyle=g;surfaceContext.fillRect(0,0,1000,1400);
        }
        const wLimit=surface.width*Number(controls.size.value)/100;
        const hLimit=surface.height*(view==='insert'?.40:.65);
        const factor=Math.min(wLimit/prepared.width,hLimit/prepared.height);
        const width=prepared.width*factor,height=prepared.height*factor;
        const margin=surface.width*.08, marginY=surface.height*.1;
        const x=margin+(surface.width-width-2*margin)*Number(controls.x.value)/100;
        const y=marginY+(surface.height-height-2*marginY)*Number(controls.y.value)/100;
        surfaceContext.globalAlpha=.94;surfaceContext.drawImage(prepared,x,y,width,height);
        const quad=view==='lid' ? [[65,508],[638,262],[897,441],[304,755]] : [[628,480],[782,578],[576,733],[414,634]];
        warp(ctx,surface,quad.map(([x,y])=>[x,y+offset]));

      }
      if(view==='insert'){
        const detail=makeCanvas(1000,900);detail.getContext('2d').drawImage(canvas,0,0);
        ctx.fillStyle='#fff';ctx.fillRect(0,0,1000,900);ctx.drawImage(detail,260,390,705,525,0,78,1000,745);
      }
      canvas.setAttribute('aria-label',`${original?'Original packaging':logo?'Your logo':'Example logo'} on ${view==='lid'?'the closed box lid':'the insert in the open presentation box'}. Illustrative preview.`);
      $('[data-pkg-download]').disabled=false;
    };
    const schedule = () => {if(!frame)frame=requestAnimationFrame(render);};
    const sync = () => {
      $('[data-pkg-size-output]').textContent=controls.size.value+'%';
      $('[data-pkg-paper-wrap]').hidden=view!=='insert';
      $('[data-pkg-caption]').textContent=view==='lid'?'Box lid · custom packaging from 100 kits':'Branded insert · available from 25 kits';
      $('[data-pkg-original]').setAttribute('aria-pressed',String(original));
      $('[data-pkg-original]').textContent=original?'Back to your design':'Compare with original';
      for(const button of root.querySelectorAll('[data-pkg-view]'))button.setAttribute('aria-pressed',String(button.dataset.pkgView===view));
      schedule();
    };
    const saveSettings = () => {for(const key of Object.keys(controls))views[view][key]=key==='remove'?controls[key].checked:controls[key].value;};
    for(const [key,control] of Object.entries(controls))control.addEventListener('input',()=>{
      original=false;
      if(key==='paper' && controls.ink.value!=='original' && controls.ink.value!=='silver')controls.ink.value=controls.paper.value==='light'?'black':'white';
      saveSettings();if(key==='ink'||key==='remove'||key==='paper')prepare();sync();
    });
    root.querySelectorAll('[data-pkg-view]').forEach(button=>button.addEventListener('click',()=>{
      saveSettings();view=button.dataset.pkgView;original=false;
      for(const key of Object.keys(controls)){if(key==='remove')controls[key].checked=views[view][key];else controls[key].value=views[view][key];}
      prepare();sync();
    }));
    $('[data-pkg-original]').addEventListener('click',()=>{original=!original;sync();});
    $('[data-pkg-centre]').addEventListener('click',()=>{controls.x.value='50';controls.y.value='50';original=false;saveSettings();sync();});
    $('[data-pkg-reset]').addEventListener('click',()=>{
      uploadVersion++;logo=null;filename='';$('[data-pkg-file]').value='';original=false;
      for(const name of ['lid','insert'])Object.assign(views[name],{size:name==='lid'?'55':'70',x:'50',y:'50',ink:'white',paper:'dark',remove:false});
      for(const key of Object.keys(controls)){if(key==='remove')controls[key].checked=false;else controls[key].value=views[view][key];}
      pendingUpload?.abort();pendingUpload=null;resetVerification();announce(screeningReady?'Example logo shown. Verify again to add a logo.':'Custom uploads are temporarily unavailable. You can still try the example logo.');prepare();sync();
    });
    const fileInput=$('[data-pkg-file]'), consent=$('[data-pkg-consent]');
    let screeningReady=false, sitekey='', token='', widget=null, pendingUpload=null, verifierLoading=null, preserveVerificationStatus=false;
    let verificationWaiter=null, verificationError=null, verificationVersion=0;
    const endpoint=root.dataset.screening;
    const updateUpload=()=>{
      fileInput.disabled=!screeningReady||!consent.checked||!!pendingUpload;
      $('.csb-packaging-upload').dataset.disabled=String(fileInput.disabled);
    };
    const resetVerification=(keepStatus=false)=>{
      preserveVerificationStatus=keepStatus;
      token='';if(widget!==null&&window.turnstile){verificationError=null;window.turnstile.reset(widget);}updateUpload();
    };
    const waitForVerification=(signal)=>{
      if(signal.aborted)return Promise.reject(new DOMException('Upload cancelled.','AbortError'));
      if(token)return Promise.resolve();
      if(verificationError)return Promise.reject(verificationError);
      return new Promise((resolve,reject)=>{
        const finish=(error)=>{signal.removeEventListener('abort',cancel);verificationWaiter=null;error?reject(error):resolve();};
        const cancel=()=>finish(new DOMException('Upload cancelled.','AbortError'));
        verificationWaiter=finish;signal.addEventListener('abort',cancel,{once:true});
      });
    };
    const loadVerifier=()=>{
      if(window.turnstile)return Promise.resolve();
      if(verifierLoading)return verifierLoading;
      verifierLoading=new Promise((resolve,reject)=>{
        const script=document.createElement('script');
        script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';script.async=true;
        const timeout=setTimeout(()=>reject(new Error('Verification could not load. Please reload the page.')),15000);
        script.onload=()=>{clearTimeout(timeout);resolve();};
        script.onerror=()=>{clearTimeout(timeout);reject(new Error('Verification could not load. Please reload the page.'));};
        document.head.appendChild(script);
      });return verifierLoading;
    };
    consent.addEventListener('change',async()=>{
      const verificationRun=++verificationVersion;
      if(!consent.checked){uploadVersion++;pendingUpload?.abort();pendingUpload=null;token='';preserveVerificationStatus=false;if(widget!==null){window.turnstile?.remove(widget);widget=null;}updateUpload();return;}
      verificationError=null;updateUpload();announce('');
      try{
        await loadVerifier();if(!consent.checked||!screeningReady||verificationRun!==verificationVersion)return;
        if(widget!==null)window.turnstile.remove(widget);
        widget=window.turnstile.render($('[data-pkg-verification]'),{
          sitekey,action:'logo_preview',theme:'light',size:'flexible',
          callback:value=>{if(!consent.checked||verificationRun!==verificationVersion)return;token=value;verificationError=null;verificationWaiter?.();updateUpload();if(!pendingUpload&&!preserveVerificationStatus)announce('');preserveVerificationStatus=false;},
          'expired-callback':()=>{if(verificationRun!==verificationVersion)return;token='';updateUpload();if(!pendingUpload)announce('');},
          'error-callback':()=>{if(verificationRun!==verificationVersion)return;token='';verificationError=new Error('Verification is unavailable. Please reload the page and try again.');verificationWaiter?.(verificationError);updateUpload();announce(verificationError.message,true);}
        });
      }catch(error){if(verificationRun!==verificationVersion)return;verificationError=error;verificationWaiter?.(error);announce(error.message,true);updateUpload();}
    });
    fetch(endpoint+'/config',{mode:'cors',credentials:'omit',cache:'no-store',signal:AbortSignal.timeout(10000)})
      .then(async response=>{if(!response.ok)throw new Error();const config=await response.json();
        if(config.enabled!==true||typeof config.sitekey!=='string'||!config.sitekey)throw new Error();
        screeningReady=true;sitekey=config.sitekey;consent.disabled=false;
        announce('');updateUpload();
      }).catch(()=>{announce('Custom uploads are temporarily unavailable. You can still try the example logo.');updateUpload();});
    fileInput.addEventListener('change',async(event)=>{
      const file=event.target.files?.[0];if(!file)return;
      if(!screeningReady||!consent.checked||pendingUpload){event.target.value='';return;}
      const version=++uploadVersion;
      if(!/\.png$/i.test(file.name)||file.type!=='image/png'||file.size>10*1024*1024||file.size<57){announce('Upload a PNG logo only, smaller than 10 MB. JPG, PDF and other file types are not accepted.',true);event.target.value='';return;}
      const controller=new AbortController();pendingUpload=controller;updateUpload();
      const deadline=setTimeout(()=>controller.abort(),60000);let url;
      try{
        const header=new Uint8Array(await file.slice(0,33).arrayBuffer());
        if(![137,80,78,71,13,10,26,10].every((value,i)=>header[i]===value))throw new Error('This is not a valid PNG. Export your logo as a PNG and try again.');
        const data=new DataView(header.buffer),width=data.getUint32(16),height=data.getUint32(20);
        if(width<1||height<1||width>8192||height>8192||width*height>24000000)throw new Error('This image is unusually large. Export it below 8192 pixels per side and 24 megapixels; we resize ordinary logos automatically.');
        if(version!==uploadVersion||!consent.checked)return;
        if(!token)announce('Logo selected. Finishing verification before screening…');
        await waitForVerification(controller.signal);
        if(version!==uploadVersion||!consent.checked||!token||controller.signal.aborted)return;
        announce('Screening your logo. It will appear only after approval…');
        const oneUseToken=token;token='';
        const response=await fetch(endpoint+'/screen',{method:'POST',mode:'cors',credentials:'omit',cache:'no-store',headers:{'Content-Type':'image/png','X-Turnstile-Token':oneUseToken},body:file,signal:controller.signal});
        if(!response.ok){const result=await response.json().catch(()=>({}));throw new Error(result.message||'Logo screening is unavailable. Please try again later.');}
        if(response.headers.get('Content-Type')?.split(';')[0]!=='image/png')throw new Error('Logo screening returned an invalid response. Please try again later.');
        const approved=await response.blob();if(approved.size>6*1024*1024)throw new Error('This logo could not be prepared. Please try a smaller PNG.');
        if(version!==uploadVersion||!consent.checked)return;
        // The original file is never decoded or drawn by the preview.
        url=URL.createObjectURL(approved);const image=await loadImage(url);
        if(version!==uploadVersion||!consent.checked)return;
        if(image.width>1200||image.height>1200)throw new Error('Invalid screened image. Please try again later.');
        const processed=makeCanvas(image.width,image.height);processed.getContext('2d').drawImage(image,0,0);
        logo=processed;filename='Approved logo';original=false;
        for(const item of Object.values(views))item.ink='original';
        controls.ink.value='original';prepare();sync();showPreview();
        announce('Logo approved and added. Original colours preserved.');
      }catch(error){if(version===uploadVersion)announce(error.name==='AbortError'?'Screening timed out. Please try again.':error.message||'Unable to screen this logo. Please try again later.',true);}
      finally{clearTimeout(deadline);if(url)URL.revokeObjectURL(url);event.target.value='';if(version===uploadVersion){pendingUpload=null;resetVerification(true);}}
    });
    $('[data-pkg-download]').addEventListener('click',()=>{
      if(!images)return;render();
      const output=makeCanvas(1400,1360),context=output.getContext('2d');
      context.fillStyle='#fff';context.fillRect(0,0,1400,1360);context.drawImage(canvas,0,0,1400,1260);
      context.fillStyle='#20252c';context.font='500 23px Arial';context.fillText(`Crypto Seed Bank | ${view==='lid'?'Box lid':'Branded insert'} ${original?'— original':'— packaging preview'}`,45,1290);
      context.fillStyle='#58616c';context.font='17px Arial';context.fillText('Illustrative mockup. Final artwork, print colours and placement confirmed before production.',45,1325);
      try{output.toBlob(blob=>{
        if(!blob){announce('The download could not be prepared. Please try again.',true);return;}
        const url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;link.download=`crypto-seed-bank-${view}-mockup.png`;document.body.appendChild(link);link.click();link.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
        announce('Mockup prepared. Check your downloads, then attach it to your quote email when you are ready.');
      },'image/png');}catch(error){announce('Download unavailable in this browser. Please try another browser.',true);}
    });
    Promise.all([loadImage(root.dataset.blank),loadImage(root.dataset.original),loadImage(root.dataset.open)]).then(([blank,originalImage,open])=>{
      images={blank,original:originalImage,open};$('[data-pkg-loading]').hidden=true;prepare();sync();
    }).catch(()=>{$('[data-pkg-loading]').textContent='The photos could not load. Refresh the page to try again.';});
  });
})();
